import { render, staticRenderFns } from "./Is-Loading.vue?vue&type=template&id=66a7da96&lang=pug"
import script from "./Is-Loading.vue?vue&type=script&lang=js"
export * from "./Is-Loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports